import React, { useState } from 'react';
import { X, Heart, ChevronRight } from 'lucide-react';
import { isIosApp } from '../utils/platform';

/**
 * SupportBanner — invites visitors to support the app (don, partage).
 * Opens the "Soutenez l'application" popup. Dismissible via localStorage.
 */
const BetaTesterBanner = () => {
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem('support_banner_dismissed') === 'true';
  });

  const handleDismiss = () => {
    localStorage.setItem('support_banner_dismissed', 'true');
    setDismissed(true);
  };

  const openSupport = () => {
    window.dispatchEvent(new Event('hypnose-open-support'));
  };

  if (dismissed || isIosApp()) return null;

  return (
    <div className="mb-6 rounded-2xl overflow-hidden border border-amber-500/30 bg-gradient-to-br from-amber-500/15 to-pink-500/10 backdrop-blur-xl" data-testid="support-banner">
      <button onClick={openSupport} className="w-full flex items-center justify-between p-4 hover:bg-amber-500/5 transition text-left" data-testid="support-banner-link">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center flex-shrink-0 shadow-[0_0_12px_rgba(245,158,11,0.4)]">
            <Heart size={18} className="text-black" />
          </div>
          <div className="min-w-0">
            <p className="text-amber-100 font-semibold text-sm">Soutenez l&apos;application</p>
            <p className="text-amber-200/70 text-xs mt-0.5">Don · Partage WhatsApp &amp; Instagram · 100% gratuite</p>
          </div>
          <ChevronRight size={16} className="text-amber-300 flex-shrink-0" />
        </div>
        <span
          role="button"
          onClick={(e) => { e.stopPropagation(); handleDismiss(); }}
          className="text-amber-200/50 hover:text-amber-100 p-1 flex-shrink-0 ml-2 cursor-pointer"
          data-testid="support-banner-close"
          aria-label="Fermer"
        >
          <X size={16} />
        </span>
      </button>
    </div>
  );
};

export default BetaTesterBanner;
